import { createAction } from '@reduxjs/toolkit'
import { Dam } from 'src/types/dam'

// Lấy toàn bộ danh sách đập
export const DAMS_GET_ALL = createAction<{ dams: Dam[] }>('@dams/GET_ALL')

// Tìm kiếm đập theo tên
export const DAMS_GET_BY_NAME = createAction<{ dams: Dam[] }>('@dams/GET_BY_NAME')

// Lấy thông tin chi tiết một đập theo ID
export const DAMS_GET_BY_ID = createAction<{ dam: Dam }>('@dams/GET_BY_ID')

// Thêm mới một đập
export const DAMS_CREATE = createAction<{ dam: Dam }>('@dams/CREATE')

// Cập nhật thông tin một đập
export const DAMS_UPDATE = createAction<{ dam: Dam }>('@dams/UPDATE')

// Xóa một đập
export const DAMS_DELETE = createAction<{ damId: string }>('@dams/DELETE')
